export const LEGEND_LABEL = {
    INCIDENT: 'Incident',
    INCIDENT_WITH_DESCRIPTION: 'Incident (with description)',
    INCIDENT_NO_DESCRIPTION: 'Incident (no description)',
    INCIDENT_COUNT: 'Incident Count',
};

export const NO_DESCRIPTION_AVAILABLE = 'No description available';
export const NO_DATA = 'No data';

// Report
export const TOTAL_INCIDENTS = 'reported incidents globally';

export const REPORT_LABELS = {
    HEALTH_FACILITIES_DAMAGED_DESTROYED: 'Health facilities damaged',
    HEALTH_WORKERS_ARRESTED: 'Health workers arrested',
    HEALTH_WORKERS_KIDNAPPED: 'Health workers kidnapped',
    HEALTH_WORKERS_KILLED: 'Health workers killed',
    PERPETRATOR_CATEGORY: 'Reported perpetrator',
    WEAPON_CATEGORY: 'Weapon category used',
    HEALTH_MEASURE_CATEGORY: 'Motive for outbreak related violence',
};
